import React from 'react'

import { Route } from 'react-router-dom'

import { Box } from '@driftt/dds'
import { NavigationHeader } from '@driftt/tide-core'

import { StyledMainContentContainer } from 'layouts/CubeReportsLayout/constants'
import AvailabilityPage from 'pages/availability'

const AvailabilityReport = () => {
  return (
    <Route exact path="/availability">
      <Box className="reports-layout">
        <NavigationHeader title="Availability" />
        <StyledMainContentContainer
          fullWidth
          fullHeight
          direction="column"
          gap={2}
        >
          <AvailabilityPage />
        </StyledMainContentContainer>
      </Box>
    </Route>
  )
}

export default AvailabilityReport
